import { isoToBusinessTime, toBusinessDate } from 'config/time';
import { REASON_FIELD_TYPE } from 'reusable/Dialog/dialogInterface';

// ADM-04。編集欄は日本時間の業務日・時刻で出す（端末の現地時刻に依存しない）。
type DateValue = string | Date | null | undefined;
const extractDate = (datetime: DateValue): string => toBusinessDate(datetime);
const extractTime = (datetime: DateValue): string =>
  isoToBusinessTime(datetime instanceof Date ? datetime.toISOString() : datetime);

export const attendanceSortingOptions = (t: Function) => [
  // 『既定』はサーバーの既定の並び（新しい順 -check_in）。check_in を送ると古い順になっていた。
  { label: t('sort.default', { ns: 'common' }), value: '' },
  { label: t('sort.driver-name', { ns: 'common' }), value: 'user__name' },
];

export interface Attendances {
  id: string;
  create_time: Date;
  update_time: Date;
  user: {
    name: string;
    // EV-289。古い API は返さない（配備の途中）。
    phone?: string;
    email: string;
    profile_picture: string;
  };
  check_in: Date;
  check_out: Date;
  overtime_duration: string;
}

export const editAttendanceFields = (t: any, data: any = {}) => {
  return [
    {
      label: t('edit.checkin-date'),
      type: 'date',
      name: 'check_in_date',
      isRequired: false,
      value: extractDate(data.check_in),
    },
    {
      label: t('edit.checkin-time'),
      type: 'time',
      name: 'check_in_time',
      isRequired: false,
      value: extractTime(data.check_in),
      // EV-116（照合の懸念4）。元の時刻。変えずに保存するときの前後の検査に使う。
      originalIso: data.check_in ? String(data.check_in) : null,
    },
    {
      label: t('edit.checkout-date'),
      type: 'date',
      name: 'check_out_date',
      isRequired: false,
      value: extractDate(data.check_out),
    },
    {
      label: t('edit.checkout-time'),
      type: 'time',
      name: 'check_out_time',
      isRequired: false,
      value: extractTime(data.check_out),
      originalIso: data.check_out ? String(data.check_out) : null,
    },
    correctionReasonField(t),
  ];
};

/**
 * BE-09-AC5（RA-AC1、2026-10-11 PM 承認の D1）。勤怠・作業の修正の理由の欄。サーバーは理由を必須にし、
 * 修正の前後と一緒に記録する。編集ダイアログが種類 reason を複数行の欄で描き、空・長すぎを止める。
 */
export const correctionReasonField = (t: any) => ({
  label: t('edit.reason-label', { ns: 'attendance' }),
  type: REASON_FIELD_TYPE,
  name: 'reason',
  isRequired: false,
  value: '',
});

/** RA-AC3。PATCH の本文に入れる理由（前後の空白を除く）。 */
export const correctionReason = (data: Record<string, unknown>): string =>
  typeof data.reason === 'string' ? data.reason.trim() : '';
